import { NumberRange } from "..";

export const parseFilterFromUrl = (
    filterParam: string | null,
): Record<string, string> => {
    if (!filterParam) return {};
    try {
        const filterObj = JSON.parse(filterParam);
        const result: Record<string, string> = {};

        Object.entries(filterObj).forEach(([key, value]: [string, any]) => {
            if (value?.contains?.[0]) {
                result[key] = value.contains[0];
            } else if (value?.eq?.[0]) {
                result[key] = value.eq[0];
            } else if (value?.gt || value?.lt) {
                const range: NumberRange = {
                    min: value.gt?.[0] ? Number(value.gt[0]) : null,
                    max: value.lt?.[0] ? Number(value.lt[0]) : null,
                };
                result[key] = JSON.stringify(range);
            }
        });
        return result;
    } catch {
        return {};
    }
};
